import { Center, Skeleton } from '@chakra-ui/react';
import React from 'react';

export const ContactCardLoader = () => {
  return (
    <Center
      w="100%"
      display="flex"
      justifyContent="center"
      flexDirection="column"
    >
      <Skeleton w="230px" height="20px" mt={6} />
      <Skeleton w="200px" height="10px" mt={3} />
      <Skeleton w="130px" height="10px" mt={3} />
    </Center>
  );
};
